import React from 'react';
import { get, isEmpty, find } from 'lodash';
import { CheckBookingState } from '../booking-status';
import { PageSpinner } from '../../shared-components/decorators/spinner';
import { StreamChat } from '../../elements-stream/stream-chat/stream-chat';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { MessageContainer } from '../message-container';

const ChatRenderer = ({
  details,
  thread,
  name,
  responsiveness,
  getFullMessage,
  spinner,
  actionFn,
  actionCb,
  msgError,
  contractData,
  accessToken,
  profile,
  generateMessageMetadata,
  env,
  bundleUpdateRequest,
  intl,
  showFlaggingSuccessBanner
}) => {
  const bookingState = CheckBookingState(details);
  const isNoAuth = 'NO_AUTH' === bookingState;
  const isDisabled = 'NO_STATE' === bookingState
    || (isNoAuth && !thread.msgs.length);

  const showChatLoader = isEmpty(get(env, 'web'));
  const isStreamEnabled = get(env, 'web.stream_enabled');
  const streamApiKey = get(env, 'web.stream_key');
  const threadStreamChannelId = get(thread, 'stream_channel_id', '');
  const streamChannelId = get(details, 'stream_channel_id') || threadStreamChannelId;
  const showStreamUI = isStreamEnabled && !!streamChannelId;
  const canSendMessages = !get(
    find(contractData, 'master'),
    'metadata.fc_rejection',
    false
  );

  const messages = _.sortBy(thread?.msgs || [], 'created');

  const msgObj = {
    messages,
    responsiveness,
    display_responsiveness: thread.display_responsiveness,
    messageCount: thread.not_sent_msg_count,
    totalMsgs: thread.total_msg_count,
    getFullMessage,
    spinner,
    textArea: {
      avatarId: profile.data.avatar_id,
      actionFn,
      actionCb,
      msgError,
      disabled: isDisabled,
      isDisableSpinning: isDisabled,
      metaData: [
        {
          inputFieldName: 'msg_host',
          elementID: 'message',
          ref: 'msgHost',
          optional: false,
          hideRequired: true,
          placeholder:
            isNoAuth && !thread.msgs.length
              ? intl.formatMessage(
                {
                  id: 'inbox.message_inbox.fix_payment',
                  defaultMessage:
                    'Please fix your payment to communicate with {name}.'
                },
                { name: name }
              )
              : intl.formatMessage(
                {
                  id: 'inbox.message_inbox.message',
                  defaultMessage: 'Message {name}'
                },
                { name: name }
              ),
          disabled: isDisabled
        }
      ]
    }
  };

  if (showChatLoader) {
    return <PageSpinner additionalStyle="gray"/>;
  }

  if (showStreamUI) {
    return <StreamChat
      channelId={streamChannelId}
      profile={profile}
      accessToken={accessToken}
      streamApiKey={streamApiKey}
      responsiveness={responsiveness}
      generateMessageMetadata={generateMessageMetadata}
      thread={thread}
      fetchBooking={bundleUpdateRequest}
      bookingId={details?.booking_id ?? ''}
      bookingState={details?.obj_state ?? ''}
      viewAs={details?.view_as ?? ''}
      showFlaggingSuccessBanner={showFlaggingSuccessBanner}
    />;
  }

  if (canSendMessages) {
    return <MessageContainer {...msgObj} {...details} streamChannelId={streamChannelId}/>;
  }

  return null;
};

ChatRenderer.propTypes = {
  details: PropTypes.object,
  thread: PropTypes.object,
  name: PropTypes.string,
  responsiveness: PropTypes.object,
  getFullMessage: PropTypes.func,
  spinner: PropTypes.bool,
  actionFn: PropTypes.func,
  actionCb: PropTypes.func,
  msgError: PropTypes.string,
  contractData: PropTypes.array,
  accessToken: PropTypes.string,
  profile: PropTypes.object,
  generateMessageMetadata: PropTypes.func,
  env: PropTypes.object,
  bundleUpdateRequest: PropTypes.func,
  intl: intlShape,
  showFlaggingSuccessBanner: PropTypes.func
};

export default ChatRenderer;
